export const navigationPaths = {
  home: '/',
  clinicalFormConfiguration: '/clinical-form-configuration',
  builder: '/builder',
  mfxPreview: 'https://mfx-preview.optimalcare.com/',
  preview: '/preview',
}
